import { FormControl } from '@angular/forms';
import { FormUtils } from '../classes/form-utils.class';
import { NotesEntryMaxLengthsEnum } from '../enums';

export function NotesEntryContentMaxLengthValidator(control: FormControl) {
  const count = FormUtils.getDecodedCharacterCount(control.value);
  return count > NotesEntryMaxLengthsEnum.CONTENT ? { maxLength: true } : null;
}
